"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.$putActivity = exports.$postActivity = exports.$getActivities = exports.$deleteActivity = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/activities';
var $deleteActivity = _activity => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(_activity)
});
exports.$deleteActivity = $deleteActivity;
var $getActivities = (limit, page) => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "?pageSize=").concat(limit, "&page=").concat(page)
});
exports.$getActivities = $getActivities;
var $postActivity = content => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base),
  body: {
    content
  }
});
exports.$postActivity = $postActivity;
var $putActivity = (_activity, content) => (0, _oldHttpClient.apiClient)({
  method: 'put',
  url: "".concat(base, "/").concat(_activity),
  body: {
    content
  }
});
exports.$putActivity = $putActivity;
var _default = exports.default = {
  $deleteActivity,
  $getActivities,
  $postActivity,
  $putActivity
};